import { render } from "./edit_2.vue?vue&type=template&id=fc9fa3e2&ts=true"
import script from "./edit_2.vue?vue&type=script&lang=ts"
export * from "./edit_2.vue?vue&type=script&lang=ts"

import "./edit_2.vue?vue&type=style&index=0&id=fc9fa3e2&lang=scss"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__